import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function TargetAudience() {
  return <section className="bg-brand-white px-4 py-20 sm:px-6 lg:px-8" data-id="element-216">
      <div className="mx-auto max-w-5xl grid gap-12 md:grid-cols-2" data-id="element-217">
        {/* Is For You */}
        <div className="rounded-2xl bg-gray-50 p-8 border border-gray-200" data-id="element-218">
          <h3 className="mb-6 text-2xl font-bold text-brand-black" data-id="element-219">
            Cierre 2.0 es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-220">
            {['Vendes cualquier producto o servicio por WhatsApp', 'Tienes prospectos pero no logras convertirlos en clientes', 'Sientes que tu precio siempre parece "caro"', 'Quieres dejar de depender de descuentos para cerrar', 'Buscas un método práctico, no teoría genérica', 'Quieres resultados desde el primer chat después de leer'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-221">
                <CheckCircle2Icon className="h-6 w-6 text-brand-green flex-shrink-0 mt-0.5" data-id="element-222" />
                <span className="text-gray-700 font-medium" data-id="element-223">{text}</span>
              </li>)}
          </ul>
        </div>

        {/* Is NOT For You */}
        <div className="rounded-2xl bg-red-50 p-8 border border-red-100" data-id="element-224">
          <h3 className="mb-6 text-2xl font-bold text-brand-black" data-id="element-225">
            Cierre 2.0 NO es para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-226">
            {['Buscas una solución mágica sin aplicar nada', 'No vendes activamente por WhatsApp', 'Prefieres seguir improvisando cada conversación', 'No estás dispuesto a cambiar tu forma de comunicarte'].map((text, i) => <li key={i} className="flex items-start gap-3" data-id="element-227">
                <XCircleIcon className="h-6 w-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-228" />
                <span className="text-gray-700 font-medium" data-id="element-229">{text}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}